import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Stack, Typography } from "@mui/material";
import StyledTextarea from "./ApplicationNotes";
import { updateNotes, applicationSelector } from "../../store/slices/applicationFormSlice";

const EditorNotes = React.memo(({ isDisableApplicationEdit }) => {
  const dispatch = useDispatch();
  const application = useSelector(applicationSelector);

  const notes = application?.notes?.value;

  const [noteValue, setNoteValue] = React.useState("");

  React.useEffect(() => {
    if (notes?.blocks) {
      setNoteValue("");
    } else {
      setNoteValue(notes || "");
    }
  }, [notes]);

  const handle = {
    onChange: (event, key) => {
      setNoteValue(event.target.value);
    },
    onBlur: (event, key) => {
      dispatch(
        updateNotes({
          value: noteValue,
          application: application._id,
          _id: application.notes?._id,
        }),
      );
    },
  };

  return (
    <Box style={{ marginTop: "20px", padding: "0 15px 20px 15px" }}>
      <Stack
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "5px",
        }}
      >
        <Typography style={{ fontWeight: 700 }}> Application Notes:</Typography>
        <Button size="small" variant="contained" onClick={handle.onBlur} disabled={isDisableApplicationEdit}>
          Save
        </Button>
      </Stack>
      <Box style={{ border: "1px solid rgba(0, 0, 0, 0.12)", padding: "5px" }}>
        <StyledTextarea handle={handle} value={noteValue} minH={"30em"} disabled={isDisableApplicationEdit} />
      </Box>
    </Box>
  );
});

export default EditorNotes;
